export default __webpack_public_path__ + "static/media/twitter.f83871c2.svg";